import HeroSection from '../components/hero/HeroSection'
import StepSection from '../components/step/StepSection'
import StatisticSection from '../components/statistic/StatisticSection'
function Home() {
  return (
    <div>
        <HeroSection />
        <StepSection />
        <StatisticSection />
    </div>
  )
}

export default Home